import { render } from "./facebookComponent.vue?vue&type=template&id=8e7dd87c"
import script from "./facebookComponent.vue?vue&type=script&lang=js"
export * from "./facebookComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__